(function ($) {
  Drupal.behaviors.r4_anr_info = {
    attach: function (context, settings) {
      $('#r4_mod8', context).once('r4_anr_info', function () {});
    }
  };
})(jQuery);
